import { TextField } from '@mui/material';
import './i-textfield.component.scss';
import { ITextFieldProps } from './i-textfield.component';

const ITextInput = (props: ITextFieldProps) => {
    const onActionEvent = (e: any) => {
        if (props.onActionEvent) {
            props.onActionEvent(e);
        }
    }

    return <div className="i-textfield">
        <TextField
            name={props.name}
            type={props.type}
            size="small"
            onChange={onActionEvent}
            label={props.label}
            variant="outlined"
            InputProps={props.InputProps}
        /></div>

};

export default ITextInput;